import { createFileRoute } from '@tanstack/react-router';
import UserLayout from '@components/layout/UserLayout.tsx';
import { BasketPage } from '@features/basket';
import { useCart } from '@hooks/useCart.ts';

export const Route = createFileRoute('/c/$orgId/$portalId/basket')({
  component: RouteComponent,
  beforeLoad: () => {
    useCart.setState({ wizardStepId: 'basket' });
  },
});

function RouteComponent() {
  return (
    <UserLayout containerClassName="bg-white">
      <div className="container mx-auto px-4 py-8 ">
        <BasketPage />
      </div>
    </UserLayout>
  );
}
